// Read the total from the export request, independent of the displayed page's row count.
export async function fetchAllPOSExportRows(fetchPage) {
    const rows = [];
    const pageSize = 100;
    let expectedTotal;
    for (let page = 0; ; page += 1) {
        const result = await fetchPage(page, pageSize);
        if (!Array.isArray(result?.items) || !Number.isSafeInteger(result.total) || result.total < 0) {
            throw new Error("Përgjigjja e eksportit nuk është valide.");
        }
        if (expectedTotal === undefined) expectedTotal = result.total;
        if (result.total !== expectedTotal) {
            throw new Error("Lista ndryshoi gjatë eksportit. Provoni përsëri.");
        }
        const expectedPageRows = Math.min(pageSize, expectedTotal - rows.length);
        if (result.items.length !== expectedPageRows) {
            throw new Error("Eksporti nuk i mori të gjithë rreshtat.");
        }
        rows.push(...result.items);
        if (rows.length === expectedTotal) return rows;
    }
}
